<section>
  <h3> Connect Your Data</h3>
  <p>Are you ready to connect your data and ask questions to your data? Connect your data sources and ask Rapider
    to
    take actions from your data.
    Rapider's AI integration
    provides a simple way to connect your data sources, such as databases, files, and APIs, to enhance your AI
    applications.
  </p>
</section>
<rappider-card-icon-title-description-list [items]="datasourceCreateOptions"
                                           (doneClick)="onJoyrideDoneButtonClick()"
                                           (cardClick)="onEntityItemSelectedForAddingDatasource($event)">
</rappider-card-icon-title-description-list>
